module.exports = __webpack_public_path__ + "static/media/pattern.028b7771.png";